import styled from 'styled-components';
import { colors, devices } from '../../base/styled/variables.styled';
export const Container = styled.div `
  width: 100%;
  height: 100%;
  background-color: ${colors.neutral000};
`;
export const HeaderContainer = styled.div `
  border-bottom: 2px solid ${colors.neutral200};

  @media ${devices.tablets} {
    border-bottom: none;
  }
`;
export const MenuContainer = styled.div `
  border-bottom: 1px solid ${colors.neutral200};

  @media ${devices.tablets} {
    display: none;
  }
`;
export const Fragment = styled.div `
  max-width: 1280px;
  margin: 0px auto;
  position: relative;
`;
//# sourceMappingURL=HelpCenter.style.js.map